import * as Sentry from '@sentry/vue'

export const initSentry = (Vue, router) => {
  Sentry.init({
    Vue,
    dsn: 'https://265e502e20c447dcab0f26c802ab7a93@sentry.cyberproctor.ru/21',
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    tracePropagationTargets: ['localhost', /^https:\/\/verbal\.examus\.net/],

    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}
